import _ from "lodash";
import {
	COLUMN_FILTER_DATE_FORMAT,
	FILTER,
	FILTER_CONDITION,
	DATA_AREA_ID,
} from "@constant";

export const TABLE_COLUMNS = [
	{
		header: "Migrated (from CRM)",
		field: "migrated",
		type: "boolean",
	},
	{
		header: "Branch",
		field: "branch",
		type: "text",
		hidden:
			_.get(
				JSON.parse(localStorage.getItem("user-json")),
				"data_area_id"
			) != DATA_AREA_ID.VN,
	},
	{
		header: "Pure Spare Sales",
		field: "pure_spare_sales",
		type: "boolean",
	},
	{
		header: "Modified On ",
		field: "updated_at",
		type: "date",
		format: "datetime",
	},
	{
		header: "Modified By ",
		field: "modified_by_name",
		type: "text",
	},
	{
		header: "Sparks Service Order",
		field: "service_order_id",
		type: "text",
	},
	{
		header: "Description",
		field: "description",
		type: "text",
	},
	{
		header: "Total Amount Before Tax",
		field: "total_amount_before_tax",
		type: "numeric",
		format: "currency",
	},
	{
		header: "Total Amount After Tax",
		field: "total_amount",
		type: "numeric",
		format: "currency",
	},
	{
		header: "Customer Account",
		field: "customer_account",
		type: "text",
		format: "hyperlink",
		hyperlink_config: {
			mode: "redirect-to-listing",
			url: "/master-data/customers",
			filters: [{ key: "external_id", value_key: "customer_account" }],
		},
	},
	{
		header: "Customer Name",
		field: "customer_company_name",
		type: "text",
	},
	{
		header: "Invoice Account",
		field: "invoice_account",
		type: "text",
	},
	{
		header: "Invoice Name",
		field: "invoice_company_name",
		type: "text",
	},
	{
		header: "Customer Reference",
		field: "customer_reference",
		type: "text",
	},
	{
		header: "Status",
		field: "status",
		type: "text",
	},
	{
		header: "Status Reason ",
		field: "status_reason",
		type: "text",
	},
	{
		header: "FO Service Order",
		field: "fo_service_order",
		type: "text",
	},
	{
		header: "FO Error Message",
		field: "fo_error_message",
		type: "text",
	},
	{
		header: "Case ID",
		field: "service_case_id",
		type: "text",
		format: "hyperlink",
		hyperlink_config: {
			mode: "redirect-to-listing",
			url: "/cases",
			filters: [{ key: "case_id", value_key: "service_case_id" }],
		},
	},
	{
		header: "Price Include Tax",
		field: "include_tax",
		type: "boolean",
		sortable: false,
	},
	{
		header: "Currency",
		field: "currency",
		type: "text",
	},
	{
		header: "Credit Note",
		field: "is_credit_note",
		type: "boolean",
	},
	{
		header: "Original SPARKS Service Order ID",
		field: "spark_service_order_id",
		type: "text",
	},
	{
		header: "Original FO Service Order",
		field: "original_fo_service_order",
		type: "text",
	},
	{
		header: "Original SPARKS Service Order (Clone)",
		field: "spark_service_order_id_clone",
		type: "text",
	},
	{
		header: "Original FO Service Order (Clone)",
		field: "original_fo_service_order_id_clone",
		type: "text",
	},
	{
		header: "Assigned",
		field: "assigned_to_name",
		type: "text",
	},
	{
		header: "Company Chain Description",
		field: "company_chain_description",
		type: "text",
	},
	{
		header: "Segment Description",
		field: "segment_description",
		type: "text",
	},
	{
		header: "Subsegment Description",
		field: "subsegment_description",
		type: "text",
	},
	{
		header: "IDS Segment Description",
		field: "ids_segment_description",
		type: "text",
	},
	{
		header: "IDS Subsegment Description",
		field: "ids_subsegment_description",
		type: "text",
	},
	{
		header: "Vendor Spare Part Remark",
		field: "vendor_spare_part_remark",
		type: "text",
	},
	{
		header: "Created On ",
		field: "created_at",
		type: "date",
		format: "datetime",
	},
	{
		header: "Created By",
		field: "created_by_name",
		type: "text",
	},
];

export const TAB_DROPDOWNS = [
	{
		text: "All Service Orders Listing",
		value: "all",
	},
	{
		text: "Active Service Order Listing",
		value: "active_service_orders",
	},

	{
		text: "My Active Service Orders Listing",
		value: "my_active_service_orders",
	},
	{
		text: "My Released Service Orders Listing",
		value: "my_released_service_orders",
	},
	{
		text: "My Cancelled Service Orders Listing",
		value: "cancelled_service_orders",
	},
	{
		text: "My Failed Service Orders Listing",
		value: "failed_service_orders",
	},
	{
		text: "My Assigned Service Order Listing",
		value: "my_assigned_service_orders",
	},
];

export const TABLE_FILTER = {
	all: {},
	active_service_orders: {
		status_reason: [
			{
				value: "draft",
				matchMode: "equals",
				operator: "or",
			},
			{
				value: "open",
				matchMode: "equals",
				operator: "or",
			},
		],
	},
	my_active_service_orders: {
		status_reason: [
			{
				value: "draft",
				matchMode: "equals",
				operator: "or",
			},
			{
				value: "open",
				matchMode: "equals",
				operator: "or",
			},
		],
		created_by: [
			{
				value: _.get(
					JSON.parse(localStorage.getItem("user-json")),
					"external_id"
				),
				matchMode: "equals",
				operator: "and",
			},
		],
	},
	my_released_service_orders: {
		status_reason: [
			{
				value: "released-to-fo",
				matchMode: "equals",
				operator: "and",
			},
		],
		created_by: [
			{
				value: _.get(
					JSON.parse(localStorage.getItem("user-json")),
					"external_id"
				),
				matchMode: "equals",
				operator: "and",
			},
		],
	},
	cancelled_service_orders: {
		status_reason: [
			{
				value: "cancelled",
				matchMode: "equals",
				operator: "and",
			},
		],
		created_by: [
			{
				value: _.get(
					JSON.parse(localStorage.getItem("user-json")),
					"external_id"
				),
				matchMode: "equals",
				operator: "and",
			},
		],
	},
	failed_service_orders: {
		status_reason: [
			{
				value: "failed-sync-to-fo",
				matchMode: "equals",
				operator: "and",
			},
		],
		created_by: [
			{
				value: _.get(
					JSON.parse(localStorage.getItem("user-json")),
					"external_id"
				),
				matchMode: "equals",
				operator: "and",
			},
		],
	},
	my_assigned_service_orders: {
		assigned: [
			{
				value: _.get(
					JSON.parse(localStorage.getItem("user-json")),
					"external_id"
				),
				matchMode: "equals",
				operator: "and",
			},
		],
	},
};
